import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Image,
  ActivityIndicator,
  Modal,
  Platform,
  FlatList,
  Dimensions,
  PixelRatio,
  ScrollView,
} from "react-native";
import React, { useEffect, useState } from "react";
import Colours from "../../utils/Colours";
import * as ImagePicker from "expo-image-picker";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import Toast from "react-native-toast-message";
import toastConfig from "../../toasts/toastConfig";
import SuccessAlertComp from "../../alertComp/SuccessAlertComp";
import ViewMoreIcon from "../../icons/ViewMoreIcon";
import PublicProfile from "../publicProfile/PublicProfile";
import * as ImageManipulator from "expo-image-manipulator";
import * as FileSystem from "expo-file-system/legacy";
import AppTextInput from "../../utils/ColourThemes/AppTextInput";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import { useNavigation } from "@react-navigation/native";
import useAuth from "../../hooks/useAuth";

const { width, height } = Dimensions.get("window");
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const MAX_IMAGE_SIZE_MB = 1;
const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;

const UpdateProfilePage = ({
  // initialImage,
  setShowUpdateProfilePage,
  fromHomePage,
  setReloadCityImageData,
}) => {
  const { image } = useAuth();
  // const initialImage = image;
  const [isFormContainer1Clicked, setIsFormContainer1Clicked] = useState(false);
  const [isFormContainer2Clicked, setIsFormContainer2Clicked] = useState(false);
  const [isFormContainer3Clicked, setIsFormContainer3Clicked] = useState(false);
  const [isPhotoClicked, setIsPhotoClicked] = useState(false);
  const [isSocialAccountForm, setIsSocialAccountForm] = useState("");
  const [isBioBoxClicked, setIsBioBoxClicked] = useState(false);
  const [isUpdateClicked, setIsUpdateClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [isLoadingx, setIsLoadingx] = useState(false);
  const [isLoading3, setIsLoading3] = useState(false);
  const [isLoading4, setIsLoading4] = useState([]);
  const [isLoadingBio, setIsLoadingBio] = useState(false);
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [isSuccessAlertCompVisible, setIsSuccessAlertCompVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [photo, setPhoto] = useState(image);
  const [images, setImages] = useState([]);
  const [word1, setWord1] = useState("");
  const [word2, setWord2] = useState("");
  const [word3, setWord3] = useState("");
  const [bio, setBio] = useState("");
  const [userData, setUserData] = useState();
  const [socialAccount, setSocialAccount] = useState("");
  const [showPublicProfile, setShowPublicProfile] = useState(false);

  const axiosPrivate = useAxiosPrivate();
  const navigation = useNavigation();

  // Fetch user bio when the component mounts
  useEffect(() => {
    const fetchUserBio = async () => {
      try {
        setIsLoadingBio(true);
        const response = await axiosPrivate.get("/getUser/getUser");
        const userData = response.data;
        ////console.log('reSSData', response.data)

        setUserData(userData);

        // Check if bio data exists before setting state
        // if (userData.words) {
        if (userData) {
          setWord1(userData.words?.word1 || "");
          setWord2(userData.words?.word2 || "");
          setWord3(userData.words?.word3 || "");

          setBio(userData?.bio || "");
          setSocialAccount(userData?.socialAccount || "");
          setImages(userData?.images || []);
        }
      } catch (error) {
        // //console.error('Error fetching user bio:', error);
        setErrorMessage(error.response.data.message);
        setIsErrorCompVisible(true);
      } finally {
        setIsLoadingBio(false); // Stop loading
      }
    };

    fetchUserBio();
  }, []); // Runs when `userID` changes

  useEffect(() => {
    ////console.log('Images', images)
  }, [images]);

  // const pickImage = async (setPhoto, setIsLoading) => {
  //   try {
  //     setIsLoading(true);

  //     let result = await ImagePicker.launchImageLibraryAsync({
  //       // mediaTypes: ImagePicker.MediaTypeOptions.Images,
  //       mediaTypes: ["images"],
  //       allowsEditing: true,
  //       aspect: [4, 4],
  //       quality: 1,
  //     });

  //     if (!result.canceled) {
  //       ////console.log('result:', result)
  //       const imageUri = result.assets[0].uri;

  //       // Check file size using FileSystem
  //       const fileInfo = await FileSystem.getInfoAsync(imageUri);
  //       const fileSizeInMB = fileInfo.size / (1024 * 1024); // convert bytes to MB

  //       ////console.log(`Image size: ${fileSizeInMB.toFixed(2)} MB`);

  //       if (fileSizeInMB > 65) {
  //         setErrorMessage(
  //           `Image too large: The selected image is ${fileSizeInMB.toFixed(2)} MB. Please choose one below.`,
  //         );
  //         setIsErrorCompVisible(true);
  //         return; // stop further action
  //       }

  //       setImage(imageUri);
  //     }
  //     // return result.canceled ? null : result.assets[0].uri;
  //   } catch (error) {
  //     //console.error('Error picking image:', error);
  //   } finally {
  //     setIsLoading(false); // Set isLoading to false after image selection
  //   }
  // };

  const pickImage = async (setPhoto, setIsLoading) => {
    try {
      setIsLoading(true);

      let result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ["images"],
        allowsEditing: true,
        aspect: [4, 4],
        quality: 1,
      });

      if (result.canceled) return; // Exit early if the user canceled

      const currentAsset = result.assets[0];
      const imageUri = currentAsset.uri;
      let fileSizeInMB = 0;

      // 🌟 CROSS-PLATFORM FILE SIZE CHECK (Web safe)
      if (Platform.OS === "web") {
        if (currentAsset.file) {
          fileSizeInMB = currentAsset.file.size / (1024 * 1024);
        } else {
          // Fallback web blob fetch evaluation if the file handle isn't attached directly
          const response = await fetch(imageUri);
          const blob = await response.blob();
          fileSizeInMB = blob.size / (1024 * 1024);
        }
      } else {
        // Native Device file size check using expo-file-system
        const fileInfo = await FileSystem.getInfoAsync(imageUri);
        fileSizeInMB = fileInfo.size / (1024 * 1024);
      }

      // Guardrail size boundary validation check
      if (fileSizeInMB > 65) {
        setErrorMessage(
          `Image too large: The selected image is ${fileSizeInMB.toFixed(2)} MB. Please choose another.`,
        );
        setIsErrorCompVisible(true);
        return; // Stop further state execution
      }

      // 🌟 Update your hook state with the verified safe image URI string
      setPhoto(imageUri);
    } catch (error) {
      console.error("Error picking image:", error);
    } finally {
      setIsLoading(false); // Clean up the loading wheel state regardless of outcome
    }
  };

  // const pickMultiImage = async (setImages, setIsLoading, currentImages) => {
  //   try {
  //     setIsLoading(true);

  //     let result = await ImagePicker.launchImageLibraryAsync({
  //       // mediaTypes: ImagePicker.MediaTypeOptions.Images,
  //       mediaTypes: ["images"],
  //       allowsEditing: false,
  //       allowsMultipleSelection: true,
  //       aspect: [4, 4],
  //       quality: 1,
  //     });

  //     if (result.canceled) return;

  //     // const newImages = result.assets.map(asset => asset.uri);
  //     // ////console.log('newImages', newImages)

  //     const newAssets = result.assets || [];
  //     const newImageURIs = [];

  //     for (let asset of newAssets) {
  //       const fileInfo = await FileSystem.getInfoAsync(asset.uri);
  //       const fileSizeInMB = fileInfo.size / (1024 * 1024);

  //       ////console.log(`Selected image size: ${fileSizeInMB.toFixed(2)} MB`);

  //       if (fileSizeInMB > 65) {
  //         setErrorMessage(
  //           `Image too large: The selected image is ${fileSizeInMB.toFixed(
  //             2,
  //           )} MB. Please choose one below.`,
  //         );
  //         setIsErrorCompVisible(true);
  //         //  setSelectedPhoto(false);
  //         setIsLoading(false);
  //         return; // Stop processing if any image is too large
  //       }

  //       newImageURIs.push(asset.uri);
  //     }

  //     // const totalImages = [...currentImages, ...newImages];
  //     const totalImages = [...currentImages, ...newImageURIs];
  //     ////console.log('totalImages', totalImages)

  //     // Limit selection to a maximum of 3 images
  //     if (totalImages.length > 3) {
  //       // alert("You can only select up to 3 images.");
  //       setErrorMessage("You can only select up to 3 images.");
  //       setIsErrorCompVisible(true);
  //       setImages(currentImages); // Keep the previous state unchanged
  //     } else {
  //       setImages(totalImages);
  //     }

  //     // return result.canceled ? null : result.assets[0].uri;
  //   } catch (error) {
  //     //console.error('Error picking image:', error);
  //   } finally {
  //     setIsLoading(false); // Set isLoading to false after image selection
  //   }
  // };

  const pickMultiImage = async (setImages, setIsLoading, currentImages) => {
    try {
      setIsLoading(true);

      let result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ["images"],
        allowsEditing: false,
        allowsMultipleSelection: true,
        aspect: [4, 4],
        quality: 1,
      });

      if (result.canceled) return;

      const newAssets = result.assets || [];
      const newImageURIs = [];

      for (let asset of newAssets) {
        let fileSizeInMB = 0;

        // 🌟 FIX: PWA Web Check vs Native Device File System Check
        if (Platform.OS === "web") {
          if (asset.file) {
            fileSizeInMB = asset.file.size / (1024 * 1024);
          } else {
            // Fallback web fetch to evaluate Blob size if file handle missing
            const response = await fetch(asset.uri);
            const blob = await response.blob();
            fileSizeInMB = blob.size / (1024 * 1024);
          }
        } else {
          // Native device calculation using expo-file-system
          const fileInfo = await FileSystem.getInfoAsync(asset.uri);
          fileSizeInMB = fileInfo.size / (1024 * 1024);
        }

        // Check max size limit safeguards
        if (fileSizeInMB > 65) {
          setErrorMessage(`Image too large: The selected image is ${fileSizeInMB.toFixed(2)} MB.`);
          setIsErrorCompVisible(true);
          setIsLoading(false);
          return;
        }

        newImageURIs.push(asset.uri);
      }

      const totalImages = [...currentImages, ...newImageURIs];

      if (totalImages.length > 3) {
        setErrorMessage("You can only select up to 3 images.");
        setIsErrorCompVisible(true);
        setImages(currentImages);
      } else {
        setImages(totalImages);
      }
    } catch (error) {
      console.error("Error picking image:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const prepareImageForUpload = async (imageUri) => {
    try {
      const fileInfo = await FileSystem.getInfoAsync(imageUri);

      if (fileInfo.size && fileInfo.size <= MAX_IMAGE_SIZE_BYTES) {
        // Already under 1MB, return as-is
        ////console.log(`Image is already ${Math.round(fileInfo.size / 1024)} KB`);
        return imageUri;
      }

      ////console.log(`Image too large: ${Math.round(fileInfo.size / 1024)} KB, compressing...`);
      let compressRatio = 0.9;
      let compressed = null;

      while (compressRatio > 0.1) {
        compressed = await ImageManipulator.manipulateAsync(imageUri, [], {
          compress: compressRatio,
          format: ImageManipulator.SaveFormat.JPEG,
        });

        const compressedInfo = await FileSystem.getInfoAsync(compressed.uri);

        if (compressedInfo.size && compressedInfo.size <= MAX_IMAGE_SIZE_BYTES) {
          //console.log(`Compressed to ${Math.round(compressedInfo.size / 1024)} KB`);
          return compressed.uri;
        }

        compressRatio -= 0.1;
      }

      console.warn("Could not get image under 1MB. Returning best attempt.");
      return compressed ? compressed.uri : imageUri;
    } catch (error) {
      console.error("Image compression failed:", error);
      return imageUri; // fallback to original
    }
  };

  const handleChangeImage = async (index) => {
    try {
      setIsLoading4((prev) => {
        const newLoadingState = [...prev];
        newLoadingState[index] = true;
        return newLoadingState;
      });

      let result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ["images"],
        allowsEditing: true,
        aspect: [4, 4],
        quality: 1,
      });

      if (result.canceled) return; // Exit if user cancelled

      const imageUri = result.assets[0].uri;
      const currentAsset = result.assets[0];
      let fileSizeInMB = 0;

      // 🌟 1. CROSS-PLATFORM FILE SIZE CHECK (Web safe)
      if (Platform.OS === "web") {
        if (currentAsset.file) {
          fileSizeInMB = currentAsset.file.size / (1024 * 1024);
        } else {
          // Fallback web blob fetch evaluation
          const response = await fetch(imageUri);
          const blob = await response.blob();
          fileSizeInMB = blob.size / (1024 * 1024);
        }
      } else {
        // Native Device file size check
        const fileInfo = await FileSystem.getInfoAsync(imageUri);
        fileSizeInMB = fileInfo.size / (1024 * 1024);
      }

      if (fileSizeInMB > 65) {
        setErrorMessage(
          `Image too large: The selected image is ${fileSizeInMB.toFixed(2)} MB. Please choose another.`,
        );
        setIsErrorCompVisible(true);
        return;
      }

      // 🌟 2. ROBUST STATE ALTERATION BLOCK
      setImages((prevImages) => {
        const newImages = [...prevImages];
        const previousItem = prevImages[index];

        if (typeof previousItem === "string") {
          // If your state array was originally holding raw string strings, replace it with a string!
          newImages[index] = imageUri;
        } else {
          // If it was an object database document profile, keep its schema matching perfectly
          newImages[index] = {
            ...previousItem,
            _id: previousItem?._id || new Date().getTime().toString(), // Fallback ID fallback if missing
            url: imageUri,
          };
        }

        return newImages;
      });
    } catch (error) {
      console.error("Error changing image:", error);
    } finally {
      setIsLoading4((prev) => {
        const newLoadingState = [...prev];
        newLoadingState[index] = false;
        return newLoadingState;
      });
    }
  };

  // const updateImage_in_db = async () => {
  //   //console.log("We are here ");
  //   //  const newUserImageObj = { firstImage: 'images', secondImage: 'images3' }
  //   //    const updateImageObj = JSON.stringify(newUserImageObj)
  //   const formData = new FormData();
  //   //  formData.append('updateImageObj', updateImageObj)
  //   setIsLoadingx(true);
  //   if (photo !== null) {
  //     const processedUri = await prepareImageForUpload(photo);
  //     // const processedUri = image //We will not compress images anymore it will be handled by cloudinary
  //     const uriParts = processedUri.split(".");
  //     const fileType = uriParts[uriParts.length - 1];
  //     formData.append("image", {
  //       uri: Platform.OS === "ios" ? processedUri.replace("file://", "") : processedUri,
  //       type: `image/${fileType}`,
  //       name: "imagePhoto",
  //     });
  //   }

  //   //formData.append('image', processedUri);

  //   // Log the added image data
  //   // ////console.log('Appended image data:', formData);

  //   try {
  //     const response = await axiosPrivate.post(
  //       "/changeImage/changeImage",
  //       formData,
  //       // await axios.post('/giveaway', formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       },
  //     );

  //     if (response.status === 200 || response.status === 201) {
  //       Toast.show({
  //         type: "success",
  //         text1: "Success",
  //         text2: response.data.message,
  //       });
  //       setTimeout(() => {
  //         setShowUpdateProfilePage(false);
  //       }, 1000);
  //     } else {
  //       // //console.error('Unexpected response:', response.data);
  //       Toast.show({
  //         type: "error",
  //         text1: "Error",
  //         text2: "Unexpected response",
  //       });
  //     }
  //   } catch (error) {
  //     // if (error.response) {
  //     //     // //console.error('Error response from server:', error.response.data);
  //     //     Toast.show({
  //     //         type: 'error',
  //     //         text1: "Warning",
  //     //         text2: error.response.data.message,

  //     //     })

  //     // } else if (error.request) {
  //     //     // //console.error('No response received:', error.request);
  //     //     Toast.show({
  //     //         type: 'error',
  //     //         text1: 'Warning',
  //     //         text2: 'No response Recieved',
  //     //     })
  //     // } else {
  //     //     // //console.error('Error setting up the request:', error.message);
  //     //     Toast.show({
  //     //         type: 'error',
  //     //         text1: 'Error!!!',
  //     //         text2: error.message,
  //     //     })
  //     // }
  //     Toast.show({
  //       type: "error",
  //       text1: "Error",
  //       text2: "Unexpected error, please try again later",
  //     });
  //   } finally {
  //     setIsLoadingx(false);
  //   }
  // };

  const updateImage_in_db = async () => {
    //console.log("We are here");
    const formData = new FormData();
    setIsLoadingx(true);

    if (photo !== null) {
      const processedUri = await prepareImageForUpload(photo);

      // FIX: Safely parse browser blobs into raw binary chunks for PWAs
      if (Platform.OS === "web" && processedUri.startsWith("blob:")) {
        try {
          const response = await fetch(processedUri);
          const blobFile = await response.blob();

          // Append the real browser file blob straight to Multer
          formData.append("image", blobFile, "profile_image.jpg");
        } catch (err) {
          console.error("Failed to parse web blob string data:", err);
        }
      } else {
        // Native device device configuration format paths
        const uriParts = processedUri.split(".");
        const fileType = uriParts[uriParts.length - 1];

        formData.append("image", {
          uri: Platform.OS === "ios" ? processedUri.replace("file://", "") : processedUri,
          type: `image/${fileType}`,
          name: "imagePhoto",
        });
      }
    }

    try {
      const response = await axiosPrivate.post("/changeImage/changeImage", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200 || response.status === 201) {
        Toast.show({
          type: "success",
          text1: "Success",
          text2: response.data.message,
        });
        setTimeout(() => {
          setShowUpdateProfilePage(false);
        }, 1000);
      } else {
        Toast.show({
          type: "error",
          text1: "Error",
          text2: "Unexpected response",
        });
      }
    } catch (error) {
      Toast.show({
        type: "error",
        text1: "Error",
        text2: "Unexpected error, please try again later",
      });
    } finally {
      setIsLoadingx(false);
    }
  };

  const isImageSet = () => {
    if (photo && image && image === photo) {
      setErrorMessage("Please add some photos");
      setIsErrorCompVisible(true);
    } else {
      updateImage_in_db();
    }
  };

  const handleCloseModal = () => {
    setIsSuccessAlertCompVisible(false);
    setShowUpdateProfilePage(false);
  };

  const validateSingleWord = (text) => {
    if (!text) return "";
    return text.replace(/\s/g, ""); // Remove all spaces
  };

  const handleWord1 = (text) => {
    const word1 = validateSingleWord(text);
    setWord1(word1);
  };
  const handleWord2 = (text) => {
    const word2 = validateSingleWord(text);
    setWord2(word2);
  };
  const handleWord3 = (text) => {
    const word3 = validateSingleWord(text);
    setWord3(word3);
  };
  const handleBioComment = (text) => {
    ////console.log('bio comment', text)
    setBio(text);
  };
  const handleSocialAccountForm = (text) => {
    ////console.log('SocialAcct', text)
    setSocialAccount(text);
  };

  const handleUpdateClicked = async () => {
    const updatedImages = images.map((img) => {
      if (typeof img === "string") {
        return { _id: null, url: img };
      }
      return { _id: img._id || null, url: img.url };
    });

    if (updatedImages.length === 0) {
      setErrorMessage("Please select an image");
      setIsErrorCompVisible(true);
      return;
    }

    setIsUpdateClicked(true);
    setIsLoading3(true);

    try {
      const userDataObject = {
        words: { word1, word2, word3 },
        bio,
        socialAccount,
        updatedImages, // Send this list to tell backend what to keep or update
      };

      const formData = new FormData();
      formData.append("newuserData", JSON.stringify(userDataObject));

      // Append files along with their targeted index positions
      // for (let i = 0; i < updatedImages.length; i++) {
      //   const image = updatedImages[i];
      //   const imageUri = image.url;

      //   if (!imageUri || typeof imageUri !== "string" || imageUri.startsWith("http")) {
      //     continue; // Skip existing server images
      //   }

      //   const processedUri = await prepareImageForUpload(imageUri);
      //   if (!processedUri) continue;

      //   const uriParts = processedUri.split(".");
      //   const fileType = uriParts[uriParts.length - 1];

      //   // 🌟 FIX: Append using a field name containing its explicit index mapping
      //   formData.append("images", {
      //     uri: Platform.OS === "ios" ? processedUri.replace("file://", "") : processedUri,
      //     type: `image/${fileType}`,
      //     name: `image_index_${i}.${fileType}`,
      //   });
      // }

      // Inside handleUpdateClicked...
      for (let i = 0; i < updatedImages.length; i++) {
        const image = updatedImages[i];
        const imageUri = image.url;

        if (!imageUri || typeof imageUri !== "string" || imageUri.startsWith("http")) {
          continue;
        }

        const processedUri = await prepareImageForUpload(imageUri);
        if (!processedUri) continue;

        // Handle PWA Web Browser Blobs safely
        if (Platform.OS === "web" && processedUri.startsWith("blob:")) {
          try {
            const response = await fetch(processedUri);
            const blobFile = await response.blob();

            // Append the real raw binary file straight to form fields
            formData.append("images", blobFile, `image_index_${i}.jpg`);
          } catch (err) {
            console.error("Failed to parse web blob streaming asset data:", err);
          }
        } else {
          // Standard Native device mobile multi-part streaming configuration profile
          const uriParts = processedUri.split(".");
          const fileType = uriParts[uriParts.length - 1];

          formData.append("images", {
            uri: Platform.OS === "ios" ? processedUri.replace("file://", "") : processedUri,
            type: `image/${fileType}`,
            name: `image_index_${i}.${fileType}`,
          });
        }
      }

      const response = await axiosPrivate.post("/moreUserBio/moreUserBio", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status === 200 || response.status === 201) {
        setSuccessMessage(response.data.message);
        setIsSuccessAlertCompVisible(true);
      } else {
        setErrorMessage("Unexpected response");
        setIsErrorCompVisible(true);
      }
    } catch (error) {
      //console.log("errrrrrror", error);
      setErrorMessage(`Unexpected error, please try again later${error}`);
      setIsErrorCompVisible(true);
    } finally {
      setIsLoading3(false);
    }
  };

  const handlePublicProfile = () => {
    navigation.navigate("public_profile", { userData });
  };

  return (
    <View style={{ flex: 1, marginBottom: dynamicSpacing(20) }}>
      <TopHeaderComponent headerText={"My bio"} hideScreen={() => navigation.goBack()} />
      <ScrollView style={{ flex: 1 }} contentContainerStyle={styles.profileContainer}>
        {" "}
        <View style={styles.profilesImage}>
          {photo ? (
            <View>
              <Image source={{ uri: photo }} style={styles.userImage2} />

              {isLoading && (
                <View style={styles.activityLoader}>
                  <ActivityIndicator size="small" color={Colours.PRIMARY} />
                </View>
              )}
            </View>
          ) : (
            <View>
              <Image
                source={require("../../../assets/profile_image_holder.jpg")}
                style={styles.userImage2}
              />
              {isLoading && (
                <View style={styles.activityLoader}>
                  <ActivityIndicator size="small" color={Colours.PRIMARY} />
                </View>
              )}
            </View>
          )}
          <TouchableOpacity style={styles.button} onPress={() => pickImage(setPhoto, setIsLoading)}>
            <Text style={styles.updateBtnTxt}>Change</Text>
          </TouchableOpacity>
          <TouchableOpacity style={styles.button} onPress={isImageSet} disabled={isLoadingx}>
            {isLoadingx ? (
              <ActivityIndicator size="small" color="white" />
            ) : (
              <Text style={styles.updateBtnTxt}>Update</Text>
            )}
          </TouchableOpacity>
        </View>
        {isLoadingBio ? (
          <View
            style={{ flex: 1, marginTop: "5%", justifyContent: "center", alignItems: "center" }}
          >
            <ActivityIndicator size={"large"} color={Colours.PRIMARY} />
          </View>
        ) : (
          <>
            <TouchableOpacity
              style={[styles.photoViewStyle, isPhotoClicked && styles.focusedBorder]}
              onPress={() => pickMultiImage(setImages, setIsLoading1, images)}
              onPressIn={() => setIsPhotoClicked(true)}
              onPressOut={() => setIsPhotoClicked(false)}
            >
              {isLoading1 ? (
                <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
                  <ActivityIndicator size={"large"} color={Colours.PRIMARY} />
                </View>
              ) : (
                <>
                  {/* {isLoading4 ? (
                                    <ActivityIndicator size="small" color={Colours.PRIMARY} />
                                ) : (
                                    <Text style={styles.photosTxt}>
                                        Photos:
                                    </Text>
                                )} */}
                  <Text style={styles.photosTxt}>Photos:</Text>

                  {/* Display Selected Images */}
                  {images && images.length > 0 ? (
                    <FlatList
                      data={images}
                      horizontal
                      keyExtractor={(item, index) => (item?._id ?? index).toString()}
                      renderItem={({ item, index }) =>
                        isLoading4[index] ? (
                          <View style={styles.imageviewStyle3}>
                            <ActivityIndicator size="small" color={Colours.PRIMARY} />
                          </View>
                        ) : (
                          <TouchableOpacity
                            onPress={() => {
                              handleChangeImage(index);
                            }}
                          >
                            <Image
                              style={styles.imageviewStyle}
                              source={{ uri: typeof item === "string" ? item : item?.url }}
                              //source={{ uri: item }}
                            />
                          </TouchableOpacity>
                        )
                      }
                    />
                  ) : (
                    <>
                      <Image
                        style={styles.imageviewStyle2}
                        source={require("../../../assets/imagePlaceholder.jpg")}
                      />
                      <Image
                        style={styles.imageviewStyle2}
                        source={require("../../../assets/imagePlaceholder.jpg")}
                      />
                    </>
                  )}
                </>
              )}
            </TouchableOpacity>

            <View style={styles.threeformsCont}>
              <Text style={styles.textDescribeTxt}>
                At least one word that best describes you (e.g. Actor, Songwritter, etc)
              </Text>
              <View style={styles.threeFormsView}>
                <AppTextInput
                  style={[
                    styles.inputTxt,
                    isFormContainer1Clicked && styles.focusedBorder,
                    //{ borderColor: isFormContainerClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
                  ]}
                  placeholder="One"
                  // keyboardType='numeric'
                  onFocus={() => setIsFormContainer1Clicked(true)}
                  onBlur={() => setIsFormContainer1Clicked(false)}
                  value={word1}
                  onChangeText={(text) => {
                    handleWord1(text);
                  }}
                />
                <AppTextInput
                  style={[
                    styles.inputTxt,
                    isFormContainer2Clicked && styles.focusedBorder,
                    //{ borderColor: isFormContainerClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
                  ]}
                  placeholder="Two"
                  // keyboardType='numeric'
                  onFocus={() => setIsFormContainer2Clicked(true)}
                  onBlur={() => setIsFormContainer2Clicked(false)}
                  value={word2}
                  onChangeText={(text) => {
                    handleWord2(text);
                  }}
                />
                <AppTextInput
                  style={[
                    styles.inputTxt,
                    isFormContainer3Clicked && styles.focusedBorder,
                    //{ borderColor: isFormContainerClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
                  ]}
                  placeholder="Three"
                  // keyboardType='numeric'
                  onFocus={() => setIsFormContainer3Clicked(true)}
                  onBlur={() => setIsFormContainer3Clicked(false)}
                  value={word3}
                  onChangeText={(text) => {
                    handleWord3(text);
                  }}
                />
              </View>
            </View>
            <View style={styles.discribeCont}>
              <Text style={styles.textDescribeTxt}>A short Bio.</Text>
              <AppTextInput
                style={[styles.commentBox2, isBioBoxClicked && styles.focusedBorder]}
                placeholder="Bio:"
                numberOfLines={6}
                multiline
                onFocus={() => setIsBioBoxClicked(true)}
                onBlur={() => setIsBioBoxClicked(false)}
                value={bio}
                textAlignVertical="top"
                maxLength={200}
                onChangeText={handleBioComment}
              />
            </View>

            <View style={styles.socialAccountCont}>
              <Text style={styles.textDescribeTxt}>
                One other social account of yours (e.g. Facebook, Instagram, etc)
              </Text>
              <View style={styles.socialaccountView}>
                <AppTextInput
                  style={[
                    styles.inputTxt,
                    isSocialAccountForm && styles.focusedBorder,
                    //{ borderColor: isFormContainerClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
                  ]}
                  placeholder="social account"
                  // keyboardType='numeric'
                  onFocus={() => setIsSocialAccountForm(true)}
                  onBlur={() => setIsSocialAccountForm(false)}
                  value={socialAccount}
                  onChangeText={(text) => {
                    handleSocialAccountForm(text);
                  }}
                />
              </View>
            </View>

            <TouchableOpacity style={styles.viewPublicProfile} onPress={handlePublicProfile}>
              <ViewMoreIcon
                color={Colours.PRIMARY}
                height={dynamicSize(25)}
                width={dynamicSize(25)}
              />
              <Text style={styles.viewProfileTxt}>View your public profile</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={[
                styles.greyButton2,

                {
                  backgroundColor: isUpdateClicked ? Colours.PRIMARY : Colours.DARKGRAY,
                },
              ]}
              onPress={handleUpdateClicked}
              disabled={isLoading3}
            >
              {isLoading3 ? (
                <ActivityIndicator size="small" color="white" />
              ) : (
                <Text style={styles.updateProfileTxt}>Update Profile</Text>
              )}
            </TouchableOpacity>
          </>
        )}
      </ScrollView>

      <Modal
        visible={isSuccessAlertCompVisible}
        transparent={true}
        animationType="fade"
        // onRequestClose={() => setIsSuccessAlertCompVisible(false)}
      >
        <SuccessAlertComp
          message={successMessage}
          onClose={() => {
            handleCloseModal();
            fromHomePage ? setReloadCityImageData(true) : null;
          }}
        />
      </Modal>
      <Modal
        visible={isErrorCompVisible}
        transparent={true}
        animationType="fade"
        onRequestClose={() => setIsErrorCompVisible(false)}
      >
        <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
      </Modal>
      <Toast config={toastConfig} />
    </View>
  );
};

const styles = StyleSheet.create({
  profileContainer: {
    flex: 1,
    height: "100%",
    // display: "flex",
    width: "100%",
    padding: dynamicSpacing(15),
    paddingBottom: dynamicSpacing(100),
  },
  updateBtnTxt: {
    fontSize: dynamicFontSize(15),
    color: "white",
    fontFamily: "Sen-Regular",
  },
  photosTxt: {
    marginRight: dynamicSpacing(100),
    color: Colours.DARKLIGHTGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Regular",
  },
  textDescribeTxt: {
    paddingBottom: dynamicSpacing(15),
    fontSize: dynamicFontSize(13),
    color: Colours.DARKGRAY,
    fontFamily: "Sen-Regular",
  },
  imageviewStyle: {
    width: dynamicSize(45),
    height: dynamicSize(40),
    borderRadius: dynamicSize(10),
    marginLeft: dynamicSpacing(5),
  },
  imageviewStyle3: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: dynamicSize(45),
    height: dynamicSize(40),
    borderRadius: dynamicSize(10),
    marginLeft: dynamicSpacing(5),
  },
  imageviewStyle2: {
    width: dynamicSize(45),
    height: dynamicSize(40),
    borderRadius: dynamicSize(10),
  },
  viewProfileTxt: {
    fontSize: dynamicFontSize(13),
    color: Colours.PRIMARY,
    fontFamily: "Sen-Regular",
  },
  updateProfileTxt: {
    fontSize: dynamicFontSize(15),
    color: "white",
    fontFamily: "Sen-Bold",
  },
  viewPublicProfile: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginTop: dynamicSpacing(20),
    gap: dynamicSpacing(5),
  },
  threeformsCont: {
    display: "flex",
    width: "100%",
    borderRadius: dynamicSize(10),
    backgroundColor: "white",
    marginTop: dynamicSpacing(15),
    padding: dynamicSpacing(15),
  },
  socialAccountCont: {
    display: "flex",
    width: "100%",
    borderRadius: dynamicSize(10),
    backgroundColor: "white",
    marginTop: dynamicSpacing(15),
    padding: dynamicSpacing(15),
  },
  profilesImage: {
    display: "flex",
    padding: dynamicSpacing(15),
    alignItems: "center",
    flexDirection: "row",
    backgroundColor: Colours.PRIMARY_LIGHTER,
    borderRadius: dynamicSize(10),
    gap: dynamicSpacing(15),
  },
  threeFormsView: {
    display: "flex",
  },
  socialaccountView: {
    display: "flex",
  },
  userImage2: {
    width: dynamicSize(60),
    height: dynamicSize(60),
    borderRadius: dynamicSize(99),
    borderWidth: dynamicSize(1.5),
    borderColor: Colours.PRIMARY,
  },
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: dynamicSize(10),
    width: dynamicSize(100),
    height: dynamicSize(40),
    backgroundColor: Colours.PRIMARY,
  },
  activityLoader: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: dynamicSize(99),
    backgroundColor: "rgb(253, 252, 252)",
  },
  inputTxt: {
    height: dynamicSize(40),
    width: dynamicSize(250),
    padding: dynamicSpacing(10),
    borderWidth: dynamicSize(2.5),
    borderColor: Colours.LIGHTGRAY,
    borderRadius: dynamicSize(7),
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(15),
    backgroundColor: Colours.LIGHTGRAY,
    marginBottom: dynamicSpacing(10),
    marginRight: dynamicSpacing(10),
  },
  photoViewStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: dynamicSize(60),
    width: "100%",
    marginTop: dynamicSpacing(15),
    paddingLeft: dynamicSpacing(10),
    paddingRight: dynamicSpacing(10),
    borderWidth: dynamicSize(2),
    borderColor: Colours.LIGHTGRAY,
    borderRadius: dynamicSize(10),
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(15),
    backgroundColor: Colours.LIGHTGRAY,
  },
  discribeCont: {
    display: "flex",
    width: "100%",
    borderRadius: dynamicSize(10),
    backgroundColor: "white",
    marginTop: dynamicSpacing(15),
    padding: dynamicSpacing(15),
  },
  commentBox2: {
    height: dynamicSize(70),
    width: "100%",
    marginTop: dynamicSpacing(10),
    padding: dynamicSpacing(10),
    borderWidth: dynamicSize(2),
    borderColor: Colours.LIGHTGRAY,
    borderRadius: dynamicSize(10),
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(15),
    backgroundColor: Colours.LIGHTGRAY,
    marginBottom: dynamicSpacing(5),
  },
  greyButton2: {
    display: "flex",
    borderRadius: dynamicSize(10),
    justifyContent: "center",
    marginTop: dynamicSpacing(20),

    alignItems: "center",
    height: dynamicSize(55),
    width: "100%",
    backgroundColor: Colours.DARKGRAY,
  },
  focusedBorder: {
    borderColor: Colours.PRIMARY,
  },
});

export default UpdateProfilePage;
